import CInput from "../../../../components/CInput";
import CAutocomplete from "../../../../components/CAutocomplete";
import CDatePicker from "../../../../components/CDatePicker";
import CEndDatePicker from "../../../../components/CEndDatePicker";
import SearchLocation from "./SearchLocation";

const clientTypeOptions = [
  { label: "Individual", value: "INDIVIDUAL" },
  { label: "Business", value: "BUSINESS" },
];

const scopeTypeOptions = [
  { label: "Design", value: "Design" },
  { label: "Renovation", value: "Renovation" },
  { label: "Fitout / Furnishing", value: "Fitout / Furnishing" },
];

const configurationOptions = [
  { label: "Studio", value: "Studio" },
  { label: "1BR", value: "1BR" },
  { label: "2BR", value: "2BR" },
  { label: "3BR", value: "3BR" },
  { label: "4BR", value: "4BR" },
];

const unitMeasurementOptions = [
  { label: "SQFT", value: "SQFT" },
  { label: "SQM", value: "SQM" },
];

const MAX_DESCRIPTION_LENGTH = 1000;

const ProjectDetailsSection = ({
  details,
  setDetails,
  errObj,
  setErrObj,
  isDisabled,
  projectTypeOptions,
  hasSpaceChoices,
  spaceOptions,
  showUnitDropdown,
  handleDescriptionChange,
  handleScopeOfWorkChange,
  isLocked,
}) => {
  return (
    <div className="summary-section">
      <h3 className="summary-section-title">Project Details</h3>

      <div className="summary-row">
        <CAutocomplete
          label="Project Type"
          placeholder="Select project type"
          value={
            projectTypeOptions.find(
              (option) =>
                option?.project_type === details?.project_type &&
                (!details.project_type_obj ||
                  option?.project_label ===
                    details.project_type_obj.project_label)
            ) || null
          }
          onChange={(e, newValue) => {
            setDetails((prev) => ({
              ...prev,
              project_type_obj: newValue || null,
              project_type: newValue?.project_type || "",
              exp_id: newValue?.exp_id ?? newValue?.id ?? null,
              space_type: null,
              form_json: newValue ? { json_type: "" } : null,
              unit: "",
            }));
            setErrObj((prev) => ({
              ...prev,
              typeErr: false,
              typeMsg: "",
              spaceTypeErr: false,
              spaceTypeMsg: "",
              unitErr: false,
              unitMsg: "",
            }));
          }}
          options={projectTypeOptions}
          getOptionLabel={(option) => option?.project_label || ""}
          error={errObj.typeErr}
          helpertext={errObj.typeMsg}
          disabled={isLocked}
        />
        <CInput
          label="Project Name"
          placeholder="Enter project name"
          value={details?.name}
          onChange={(e) => {
            const value = e.target.value;
            setDetails((prev) => ({ ...prev, name: value }));
            setErrObj((prev) => ({ ...prev, nameErr: false, nameMsg: "" }));
          }}
          inputProps={{ maxLength: 50 }}
          error={errObj.nameErr}
          helpertext={errObj.nameMsg}
          disabled={isLocked}
        />
      </div>

      <div className="summary-row">
        <CAutocomplete
          label="Space Type"
          placeholder="Select space type"
          value={
            hasSpaceChoices
              ? spaceOptions.find(
                  (opt) => opt.value === details?.space_type?.value
                ) || null
              : details.space_type || null
          }
          onChange={(e, newValue) => {
            setDetails((prev) => ({
              ...prev,
              space_type: newValue || null,
              form_json: {
                ...(prev.form_json || {}),
                json_type: newValue?.value || "",
              },
            }));
            setErrObj((prev) => ({
              ...prev,
              spaceTypeErr: false,
              spaceTypeMsg: "",
            }));
          }}
          options={spaceOptions}
          getOptionLabel={(option) => option?.label || ""}
          error={errObj.spaceTypeErr}
          helpertext={errObj.spaceTypeMsg}
          disabled={isLocked || !hasSpaceChoices}
        />
        <CAutocomplete
          label="Customer Type"
          placeholder="Select customer type"
          value={
            clientTypeOptions.find(
              (option) => option.value === details?.client_type
            ) || null
          }
          onChange={(e, newValue) => {
            setDetails((prev) => ({
              ...prev,
              client_type: newValue?.value || "",
            }));
            setErrObj((prev) => ({
              ...prev,
              clientTypeErr: false,
              clientTypeMsg: "",
            }));
          }}
          options={clientTypeOptions}
          getOptionLabel={(option) => option?.label || ""}
          error={errObj.clientTypeErr}
          helpertext={errObj.clientTypeMsg}
        />
      </div>

      <div className="summary-row">
        <SearchLocation
          details={details}
          setDetails={setDetails}
          errObj={errObj}
          setErrObj={setErrObj}
          isDisabled={isDisabled}
        />
        <CAutocomplete
          label="Scope"
          placeholder="Select scope"
          value={
            scopeTypeOptions.find(
              (option) => option.value === details?.scope
            ) || null
          }
          onChange={(e, newValue) => {
            setDetails((prev) => ({
              ...prev,
              scope: newValue?.value || "",
            }));
            setErrObj((prev) => ({
              ...prev,
              scopeErr: false,
              scopeMsg: "",
            }));
          }}
          options={scopeTypeOptions}
          getOptionLabel={(option) => option?.label || ""}
          error={errObj.scopeErr}
          helpertext={errObj.scopeMsg}
        />
      </div>

      <div className="summary-row">
        <CAutocomplete
          label={showUnitDropdown ? "Configuration" : "Unit"}
          placeholder={
            showUnitDropdown ? "Select configuration" : "Select unit"
          }
          value={
            (showUnitDropdown
              ? configurationOptions
              : unitMeasurementOptions
            ).find((option) => option.value === details?.unit) || null
          }
          onChange={(e, newValue) => {
            setDetails((prev) => ({
              ...prev,
              unit: newValue?.value || "",
            }));
            setErrObj((prev) => ({
              ...prev,
              unitErr: false,
              unitMsg: "",
            }));
          }}
          options={
            showUnitDropdown ? configurationOptions : unitMeasurementOptions
          }
          getOptionLabel={(option) => option?.label || ""}
          error={errObj.unitErr}
          helpertext={errObj.unitMsg}
        />
        <CInput
          label="Unit Size"
          placeholder="Enter unit size"
          value={details?.unit_size}
          onChange={(e) => {
            setDetails((prev) => ({
              ...prev,
              unit_size: e.target.value,
            }));
            setErrObj((prev) => ({
              ...prev,
              unitSizeErr: false,
              unitSizeMsg: "",
            }));
          }}
          inputProps={{ maxLength: 10 }}
          error={errObj.unitSizeErr}
          helpertext={errObj.unitSizeMsg}
        />
      </div>

      <div className="summary-row">
        <CDatePicker
          label="Start Date"
          value={details.start_date}
          onChange={(date) => {
            setDetails((prev) => {
              const newErrObj = { ...errObj };
              if (prev.end_date && date) {
                if (prev.end_date <= date) {
                  newErrObj.endDateErr = true;
                  newErrObj.endDateMsg =
                    "End date must be greater than start date";
                } else {
                  newErrObj.endDateErr = false;
                  newErrObj.endDateMsg = "";
                }
              }
              newErrObj.startDateErr = false;
              newErrObj.startDateMsg = "";
              setErrObj(newErrObj);
              return { ...prev, start_date: date };
            });
          }}
          disablePast
          error={errObj.startDateErr}
          helperText={errObj.startDateMsg}
        />
        <CEndDatePicker
          label="End Date"
          minDate={details.start_date || new Date()}
          value={details.end_date}
          onChange={(date) => {
            setDetails((prev) => ({ ...prev, end_date: date }));
            setErrObj((prev) => ({
              ...prev,
              endDateErr: false,
              endDateMsg: "",
            }));
          }}
          error={errObj.endDateErr}
          helperText={errObj.endDateMsg}
        />
      </div>

      <div className="summary-row-single" style={{ paddingTop: 10 }}>
        <CInput
          multiline
          rows={4}
          label="Description"
          placeholder="Provide project description (Max upto 1000 characters allowed)"
          value={details?.description}
          onChange={handleDescriptionChange}
          error={errObj.descriptionErr}
          helpertext={
            errObj.descriptionErr
              ? errObj.descriptionMsg
              : `${
                  MAX_DESCRIPTION_LENGTH - (details?.description?.length || 0)
                } characters left`
          }
          disabled={isLocked}
        />
      </div>

      <div className="summary-row-single" style={{ paddingTop: 10 }}>
        <CInput
          multiline
          rows={4}
          label="Scope of work"
          placeholder="Write here (Max upto 1000 characters allowed)"
          value={details?.scope_of_work}
          onChange={handleScopeOfWorkChange}
          error={errObj.scopeOfWorkErr}
          helpertext={
            errObj.scopeOfWorkErr
              ? errObj.scopeOfWorkMsg
              : `${
                  MAX_DESCRIPTION_LENGTH -
                  (details?.scope_of_work?.length || 0)
                } characters left`
          }
          disabled={isLocked}
        />
      </div>
    </div>
  );
};

export default ProjectDetailsSection;
